import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { transformStreet } from 'src/app/pipes/location/street.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { LocationOption } from '../models/location-option.interface';
import { locationOptionSelectors } from '../state/location-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: LocationSelectComponent,
        },
    ],
    selector: 'ndt-location-select',
    templateUrl: './location-select.component.html',
    standalone: false
})
export class LocationSelectComponent extends LcsSingleSelectBase<LocationOption> implements OnInit {
   locations: Observable<LocationOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.locations = this.store.pipe(select(locationOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: LocationOption | null): string | null {
      if (!item) return null;
      const street = transformStreet(item);
      return item.name ? `${item?.name} - ${street}` : street;
   }

   trackBy(item: LocationOption | null) {
      return item ? item.locationId : null;
   }
}
